import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import { Link } from 'react-router-dom';

import Button from '@/components/Button';
import Logo from '@/components/Logo';
import ScrollArea from '@/components/ScrollArea';
import routes from '@/routes';
import { AUTH_MODAL_TYPES, openAuthModal } from '@/store/profile';
import { cn } from '@/utils';

import { useMenuItems } from '../hooks';

function MenuContent({ closeMenu }) {
	const { t } = useTranslation();
	const dispatch = useDispatch();
	const isLogged = useSelector(state => state.profile.loggedIn);

	const menuItems = useMenuItems();

	const renderLogo = () => (
		<div className="container flex h-[52px] items-center bg-black">
			<Logo />
		</div>
	);

	const renderBody = () => (
		<div className="container relative flex grow flex-col items-center gap-4 bg-black">
			<div className="mt-7 flex flex-col items-center gap-[28px]">
				{menuItems.map((menu, index) => (
					<Link
						size="lg"
						className="font-normal text-white"
						type="button"
						key={`menu-${index}`}
						to={menu.to}
						onClick={() => {
							closeMenu();
						}}
					>
						<span
							className={cn(
								'text-sm leading-[21px] transition-colors sm:block'
							)}
						>
							{t(menu.text)}
						</span>
					</Link>
				))}
			</div>
		</div>
	);

	const renderAuthButtons = () => (
		<div className="container flex flex-col bg-black pb-6">
			{isLogged ? (
				<Button
					Component={Link}
					to={routes.myDocuments}
					variant="outlineWhite"
				>
					{t('common.goToMyAccount')}
				</Button>
			) : (
				<div className="flex flex-row items-stretch justify-around gap-2">
					<Button
						className="w-full"
						variant="outlineWhite"
						onClick={() => {
							dispatch(openAuthModal({ type: AUTH_MODAL_TYPES.LOGIN }));
							closeMenu();
						}}
					>
						{t('common.login')}
					</Button>
					<Button
						className="w-full"
						variant="secondary"
						onClick={() => {
							dispatch(
								openAuthModal({ type: AUTH_MODAL_TYPES.SIGN_UP })
							);
							closeMenu();
						}}
					>
						{t('common.signUp')}
					</Button>
				</div>
			)}
		</div>
	);

	return (
		<ScrollArea maxHeight="100%">
			<div className="flex h-dvh flex-col gap-[100px] bg-black">
				{renderLogo()}
				{renderBody()}
				{renderAuthButtons()}
			</div>
		</ScrollArea>
	);
}

export default MenuContent;
